<template>
  <div>
    <md-card>
      <md-card-header>
        <div class="md-layout">
          <div class="md-layout-item md-size-90">
            <h4 class="title">Departure Bookings</h4>
          </div>
          <div class="md-layout-item md-size-10 text-right">
            <md-button
              v-if="$allowed('crm.route.booking')"
              class="md-icon-button md-dense md-primary md-round"
              @click.prevent="newBooking"
            >
              <md-icon>add</md-icon>
              <md-tooltip md-direction="top"
                >Add a new Booking<br />for this Departure</md-tooltip
              >
            </md-button>
          </div>
        </div>
      </md-card-header>
      <md-card-content>
        <template v-if="departure.bookings && departure.bookings.length">
          <div
            class="md-layout booking-row"
            v-for="booking in departure.bookings"
            :key="booking.id"
          >
            <h6 class="md-layout-item md-size-100">
              Reference:
              <router-link
                v-if="$allowed('crm.route.booking')"
                :to="{ name: 'Booking Profile', params: { id: booking.id } }"
                >{{ booking.id }}</router-link
              >
              <template v-else>{{ booking.id }}</template>
            </h6>
            <div class="md-layout-item md-size-25">
              <router-link
                v-if="$allowed('crm.route.customer')"
                class="lead-booker"
                :to="{
                  name: 'Customer Profile',
                  params: { id: booking.lead_booker.id }
                }"
                >{{ booking.lead_booker.full_name }}</router-link
              >
              <span v-else class="lead-booker">{{
                booking.lead_booker.full_name
              }}</span>
              <template v-for="traveller in booking.travellers">
                <div
                  :key="traveller.id"
                  v-if="traveller.user_info.id != booking.lead_booker_id"
                >
                  <router-link
                    v-if="$allowed('crm.route.customer')"
                    class="traveller"
                    :to="{
                      name: 'Customer Profile',
                      params: { id: traveller.user_info.id }
                    }"
                    >{{ traveller.user_info.full_name }}</router-link
                  >
                  <span v-else class="traveller">{{
                    traveller.user_info.full_name
                  }}</span>
                </div>
              </template>
            </div>
            <div class="md-layout-item md-size-40">
              {{ booking.booking_date | formatDate }}
            </div>
            <div class="md-layout-item md-size-25">
              <md-icon
                class="status-icon"
                :class="statusColour(booking.status.value)"
                >privacy_tip</md-icon
              >
              {{ booking.status.description }}
            </div>
            <div class="md-layout-item md-size-10 text-right md-dense actions">
              <md-button
                v-if="$allowed('crm.route.booking')"
                :to="{ name: 'Booking Profile', params: { id: booking.id } }"
                class="md-just-icon md-simple md-success"
              >
                <md-icon>visibility</md-icon>
                <md-tooltip md-direction="top">View</md-tooltip>
              </md-button>
            </div>
            <md-divider class="md-layout-item md-size-100" />
          </div>
        </template>

        <md-empty-state
          v-else
          md-label="Book 'em Danno"
          md-description="Let's get some people on this trip."
        >
          <md-button
            v-if="$allowed('crm.route.booking')"
            class="md-primary md-raised"
            @click="newBooking"
            >Create a New Booking</md-button
          >
        </md-empty-state>
      </md-card-content>
    </md-card>

    <booking-create-dialog
      :showNewBookingDialog="showNewBookingDialog"
      :departure="departure"
      @created="bookingCreated"
      @cancelled="showNewBookingDialog = false"
    />
  </div>
</template>

<script>
import BookingCreateDialog from "./BookingCreateDialog.vue";

export default {
  props: ["departure"],

  data() {
    return {
      showNewBookingDialog: false
    };
  },

  components: {
    BookingCreateDialog
  },

  methods: {
    newBooking() {
      this.showNewBookingDialog = true;
    },

    bookingCreated(booking) {
      this.showNewBookingDialog = false;
      this.$router.push({
        name: "Booking Profile",
        params: { id: booking.id }
      });
    },

    statusColour: function(status) {
      let currClass = null;
      switch (status) {
        case "pending":
        case "reserved":
          currClass = "primary";
          break;
        case "attempted":
        case "partially_paid":
          currClass = "warning";
          break;
        case "fully_paid":
          currClass = "success";
          break;
        case "cancelled":
        case "cancelled_credit":
          currClass = "danger";
          break;
      }
      return currClass;
    }
  }
};
</script>
<style lang="scss" scoped>
.booking-row {
  margin-bottom: 0.2rem;

  hr {
    margin: 0.5rem 0;
  }

  h6 {
    margin: 0;
  }

  .actions {
    align-items: flex-start;
  }

  .md-button {
    height: auto;
    margin: 0;
  }

  .lead-booker {
    font-weight: bold;
  }
  .traveller {
    margin-left: 10px;
  }

  .passenger-list {
    margin-bottom: 0.2rem;

    .tour-leader {
      color: gold;
    }
  }
}
</style>
